import enums from "raft/internal/enums";

type GetFilterValuesProps = {
  search?: string;
};

export const getCategoryClassEquipmentFilterValues = (search?: GetFilterValuesProps) => enums.category;
